
export default function FloatingButtons() {
  return (
    <div className="fixed bottom-6 right-6 z-50 flex flex-col gap-3 items-end">
      {/* Botão Instagram */}
      <a
        href="https://www.instagram.com/barbaramarcelinoadv?igsh=NWFmeHR0bmQ0NmRr&utm_source=qr"
        target="_blank"
        rel="noopener noreferrer"
        className="group flex items-center gap-3 cursor-pointer"
        aria-label="Instagram"
      >
        <span className="bg-white text-[#4A1C40] text-xs font-semibold px-3 py-1.5 rounded-full shadow-lg opacity-0 group-hover:opacity-100 transition-all duration-300 whitespace-nowrap">
          Siga no Instagram
        </span>
        <div className="w-14 h-14 flex items-center justify-center rounded-full shadow-xl transition-all duration-300 hover:scale-110"
          style={{
            background: 'linear-gradient(135deg, #f09433 0%, #e6683c 25%, #dc2743 50%, #cc2366 75%, #bc1888 100%)'
          }}
        >
          <i className="ri-instagram-line text-2xl text-white"></i>
        </div>
      </a>

      {/* Botão WhatsApp */}
      <a
        href="https://wa.me/5532998566774?text=Ol%C3%A1%2C%20gostaria%20de%20agendar%20uma%20consulta"
        target="_blank"
        rel="noopener noreferrer"
        className="group flex items-center gap-3 cursor-pointer"
        aria-label="WhatsApp"
      >
        <span className="bg-white text-[#4A1C40] text-xs font-semibold px-3 py-1.5 rounded-full shadow-lg opacity-0 group-hover:opacity-100 transition-all duration-300 whitespace-nowrap">
          Fale pelo WhatsApp
        </span>
        <div className="w-14 h-14 flex items-center justify-center bg-[#25D366] rounded-full shadow-xl transition-all duration-300 hover:scale-110 hover:bg-[#20BD5A]">
          <i className="ri-whatsapp-line text-3xl text-white"></i>
        </div>
      </a>
    </div>
  );
}
